import { useRef } from 'react'
import {
    Box,
    Card as ThemeCard,
    Flex,
    Heading,
    Image,
    Text,
} from '@theme-ui/components';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
    ImagePlaceholder,
    Skeleton,
} from '~/Common'
import { useResponsiveValue } from '@theme-ui/match-media';
import moment from 'moment';
import { DATE_FORMAT } from 'app/constants';

export const ResearchCard = ({ report, company, variant }) => {
    const nodeRef = useRef(null);
    const { t } = useTranslation();
    const isMobile = useResponsiveValue([true, true, true, false]);
    const researchDashboard = variant === 'researchDashboard';
    const imageHeight = researchDashboard ? '154px' : '124px';

    return (
        <CSSTransition
            nodeRef={nodeRef}
            in={true}
            timeout={500}
            classNames="fade"
            unmountOnExit
            appear
        >
            <ThemeCard
                as={Link}
                to={`/companies/${company?.slug}/research/${report?.slug}`}
                variant={isMobile ? 'industryNewsMobile' : variant}
                ref={nodeRef}
                mr={[2, 2, 2, 0]}
            >
                <Flex sx={{ position: 'relative', zIndex: 1, minWidth: isMobile ? '120px' : undefined }}>
                    {report ? (
                        <>
                            {report?.banner?.sizes?.thumbnail ? (
                                <Box sx={{
                                    width: '100%',
                                    height: isMobile ? '150px' : imageHeight
                                }}>
                                    <Image src={report?.banner?.original} sx={{ objectFit: 'cover', height: '100%', width: '100%' }} />
                                </Box>
                            ) : (
                                <ImagePlaceholder sx={{
                                    width: '100%',
                                    height: isMobile ? '150px' : imageHeight
                                }} />
                            )}
                        </>
                    ) : <Skeleton height="168px" />}
                </Flex>
                <Flex px={[3,3,3,3]} py={3} sx={{
                    position: 'relative',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: 1,
                    height: researchDashboard ? '130px' : 'auto',
                }}>
                    <Box sx={{ flexGrow: 1 }}>
                        {report ? <Heading as="h5" variant="h6" sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', fontSize: '14px' }}>{t(report?.title)}</Heading> : <Skeleton height="28px" width="70%" />}
                        {report ? <Text as="p" variant="p" color="dark" mt={1} sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', fontSize: '14px' }}>{company?.category?.name}</Text> : <Skeleton height="14px" width="100%" />}
                        {report ? <Text as="p" variant="h6" color="dark" mt={researchDashboard ? '38px' : 3} sx={{ fontSize: '10px' }}>{moment.utc(report?.date).format(DATE_FORMAT.month_and_year)}</Text> : <Skeleton height="14px" width="100%" />}
                    </Box>
                </Flex>
            </ThemeCard>
        </CSSTransition>
    );
};
